const TRANSLATIONS = {
  openWorkshopsOverlayAction: {
    de: 'Workshops auswählen',
    en: 'Choose workshops',
  },
  workshopRegistrationTitle: {
    de: 'Workshop Anmeldung',
    en: 'Workshop Registration',
  },
  chooseTheWorkshopTitle: {
    de: 'Wählen Sie den Workshop',
    en: 'Choose the workshop',
  },
  addToWaitingListAlert: {
    de: 'Zur Warteliste hinzufügen.',
    en: 'Add to waiting list.',
  },
  workshopFullyBookedAlert: {
    de: 'Dieser Kurs ist leider ausgebucht!',
    en: 'Sorry, this workshop is fully booked!',
  },
  workshopInPeriodAlreadyChosenAlert: {
    de: 'In diesem Zeitraum ist bereits ein Anlass gewählt.',
    en: 'A workshop has already been chosen in this period.',
  },
  chooseWorkshopAction: {
    de: 'wählen',
    en: 'choose',
  },
  signedUpFor: {
    de: 'für',
    en: 'for',
  },
  signedUpForWorkshop: {
    de: 'Workshop',
    en: 'workshop',
  },
  signedUpForWorkshops: {
    de: 'Workshops',
    en: 'workshops',
  },
  workshopChosen: {
    de: 'gewählt',
    en: 'chosen',
  },
  applySelectionAction: {
    de: 'Auswahl übernehmen',
    en: 'apply selection',
  },
  waitingList: {
    de: 'Warteliste',
    en: 'Waiting list',
  },
  summaryTitle: {
    de: 'Zusammenfassung',
    en: 'Summary',
  },
};

export const localize = window.sfp.scriptLibs.createLocalize(TRANSLATIONS);
